import { connect } from "react-redux";
import * as financingActions from "./actions";
import * as generalFinancingActions from "../actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)

function mapStateToProps(state) {
  return {
    financings: state.userFinancings.financings,
    accountInfo: state.userFinancings.accountInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFinancingsPerAccount: (accountId) => {
      dispatch(financingActions.get_account_financings(accountId));
    },

    changeFinancingListPage: (page) => {
      dispatch(financingActions.change_financing_list_page(page, "InProgress"));
    },

    getFinancingBookingAccountInfo: (accountId) => {
      dispatch(
        generalFinancingActions.get_financing_booking_account_info(accountId),
      );
    },

    changeFinancingListFilter: (type, key, value) => {
      dispatch(
        financingActions.change_financing_list_filter(key, value, "InProgress"),
      );
    },

    openFinancing: (financingId, shouldPublish) => {
      dispatch(financingActions.open_financing(financingId, shouldPublish));
    },

    closeFinancing: (financingId, shouldUnpublish) => {
      dispatch(financingActions.close_financing(financingId, shouldUnpublish));
    },

    publishFinancing: (financingId) => {
      dispatch(financingActions.publish_financing(financingId));
    },

    unPublishFinancing: (financingId) => {
      dispatch(financingActions.unpublish_financing(financingId));
    },

    cancelFinancing: (financingId) => {
      dispatch(financingActions.cancel_financing(financingId));
    },

    getFinancingPayoutInfo: (financingId, offerId, assetType) => {
      dispatch(
        financingActions.get_financing_payout_info(
          financingId,
          offerId,
          assetType,
        ),
      );
    },

    registerPayout: (financingId) => {
      dispatch(financingActions.register_financing_payout(financingId));
    },

    changeFinancingIssuedListPage: (page) => {
      dispatch(financingActions.change_financing_list_page(page, "Issued"));
    },

    changeFinancingIssuedListFilter: (type, key, value) => {
      dispatch(
        financingActions.change_financing_list_filter(key, value, "Issued"),
      );
    },

    changeFinancingReadyBeRealisedListPage: (page) => {
      dispatch(financingActions.change_financing_list_page(page, "Ready"));
    },

    changeFinancingReadyBeRealisedListFilter: (type, key, value) => {
      dispatch(
        financingActions.change_financing_list_filter(key, value, "Ready"),
      );
    },
  };
}

export const userFinancingConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
